import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'LIST_CLIENT',
  title: 'Warum sehe ich meine Kunden nicht in meiner Kundenliste?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Haben Sie die Registerkarte "Versandte Einladungen" überprüft?'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_LIST_CLIENT/DE_LIST_CLIENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Hier finden Sie die gesendeten Einladungen, die darauf warten, dass Ihr Kunde sie annimmt.'
  }]
};
